import React from 'react'
import { Button, Header, Modal } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

export interface IConfirmNavigationModal {
  isActive: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const ConfirmNavigationModal: React.FC<IConfirmNavigationModal> = props => {
  const { t } = useTranslation()
  return (
    <Modal open={props.isActive}>
      <Header content={t('global.leave_dialog_title')} />
      <Modal.Content>
        <p>{t('global.leave_dialog_text')}</p>
      </Modal.Content>
      <Modal.Actions>
        <Button content={t('global.cancel')} color='orange' icon='cancel' onClick={props.onCancel} data-testid='btn-cancel' />
        <Button content={t('global.leave_dialog_confirm')} negative onClick={props.onConfirm} data-testid='btn-confirm' />
      </Modal.Actions>
    </Modal>
  )
}
export default ConfirmNavigationModal
